// extracted by mini-css-extract-plugin
export var textInput = "_l3-0";